/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */
import type { ListSnippetsSelector } from './listSnippetsSelector';

export type ListSnippetsParams = {
selector?: ListSnippetsSelector;
search?: string | null;
creator_id?: string | null;
creator_id_not?: string | null;
/**
 * @minimum 1
 */
page?: number;
/**
 * @minimum 1
 * @maximum 50
 */
per_page?: number;
};
